<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h2>Esqueceu a senha?</h2>
            <span>Não tem problema, se você for nosso usuário, enviaremos um email para você recuperar sua conta.</span>
            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{msgSuccess}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="signin-form">
              <div class="form-group">
                <label for="emailInput">E-mail</label>
                <input type="email" class="form-control" id="emailInput" aria-describedby="emailHelp" placeholder="Informe seu e-mail" v-model="username">
              </div>

              <button type="submit" class="btn" v-on:click.stop.prevent="sendMail()">Enviar e-mail com instruções</button>

            </form>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import auth from '../services/auth'
import { API } from '../services/api'

export default {
  name: 'ForgotPassword',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      username: null,
      persistSession: false,
      showMsg: false,
      showMsgSuccess: false,
      msg: "",
      msgSuccess: "",
      loading: false
    }
  },
  methods: {
      sendMail () {
        this.loading = true;
        if(this.validate()){
          this.$http.post(API.Auth.forgotPassword, {username: this.username}).then((response) => {
            if(response.body.success == true){
              this.msgSuccess = response.body.message;
              this.showMsgSuccess = true;
            }else{
              this.msg = response.body.message;
              this.showMsg = true;
            }
            this.loading = false;
          }, (error) => {
            console.log(error);
            this.loading = false;
          });
        }else{

        }
      },
      validate () {
        if (this.username == "" || this.username == null) {
          this.msg = 'Deve informar o seu e-mail!'
          this.showMsg = true;
          this.loading = false;
          return false;
        }
        return true;
      },
      hideMsg(){
        this.msg = "";
        this.showMsg = false;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  h2{
    font-family: RalewayBold;
  }

  span{
    font-family: RalewayRegular;
  }

  .signin-form{
    width: 100%;
    padding: 20px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 40px;
    font-family: RalewayRegular;
    margin-top: 30px;

    h5{
      position: relative;
      text-align: center;
      margin: 30px 0px;
      font-family: RalewayRegular;

      &::before{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        right: 0;
      }

      &::after{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        left: 0;
      }
    }

    small{
      a{
        font-size: 14px;
        color: #00ae39;
        font-family: RalewayBold;
        text-decoration: none;
      }
    }

    input{
      padding: 10px;
      border-color: #00ae39;
    }

    .form-check{
      padding-bottom: 10px;
    }

    button{
      width: 100%;
      margin-top: 20px;
      padding: 10px;
      font-size: 20px;
      background-color: #00ae39;
      color: #fff;
      cursor: pointer;

      &.login-facebook{
        background-color: #3b5998;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue